import { Box, SnackbarContent, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

interface QuarterlyGoalsAlertProps {
  show: boolean;
}

export const QuarterlyGoalsAlert = ({ show }: QuarterlyGoalsAlertProps) => {
  if (!show) return null;

  return (
    <SnackbarContent
      sx={{
        background: "#FFF4E5",
        color: "#ED6C02",
        marginTop: "16px",
        boxShadow: "none",
        border: "1px solid #D32F2F80",
        padding: "0 16px",
      }}
      message={
        <Box display="flex">
          <ErrorOutlineIcon sx={{ marginRight: "8px", color: "#ED6C02" }} />
          <Box>
            <Typography
              variant="body1"
              fontWeight="500"
              sx={{ marginBottom: "4px" }}
            >
              Quarterly Goals Replicated from Last Quarter
            </Typography>
            <Typography variant="body2">
              Review and customize them to align with your current goals.
            </Typography>
          </Box>
        </Box>
      }
    />
  );
};
